export default "__VITE_ASSET__rQL7qrCL__"